import * as actionTypes from "../actionTypes/eventsTypes";
import axios from "../../axios-instance";
import Swal from "sweetalert2";
import ls from 'localstorage-slim';
import { toast } from "react-toastify";
import {
  convertScanDataForStore,
  convertSellDataForStore,
  convertToDataMap,
  summedValuesDataMap,
} from "../../helpers/converter";
import { getHeaders } from "../../helpers/getHeaders";

export const clearCurrentEvent = () => ({
  type: actionTypes.CLEAR_CURRENT_EVENT,
});

const getEventsStart = () => ({ type: actionTypes.GET_EVENTS_START });
const getEventsSuccess = (events) => ({
  type: actionTypes.GET_EVENTS_SUCCESS,
  payload: events,
});
const getEventsFail = (error) => ({ type: actionTypes.GET_EVENTS_FAIL, error });

export const getEvents =
  (userToken, isPassedEvents, searchEventValue, skip, take, action = '', sortingType = 5) => (dispatch) => {
    dispatch(getEventsStart());
    return axios
      .get(
        `/Events?includeEnded=${isPassedEvents}&search=${searchEventValue}&skip=${skip}&take=${take}&action=${action}&sortingType=${sortingType}`,
        { headers: getHeaders(userToken) }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          return response.data.result;
        }
        throw new Error(response.data.errorMessage);
      })
      .then((result) => {
        dispatch(getEventsSuccess(result));
        return result;
      })
      .catch((err) => {
        dispatch(getEventsFail(err));
      });
  };

const addEventStart = () => ({ type: actionTypes.ADD_EVENT_START });
const addEventSuccess = (event) => ({
  type: actionTypes.ADD_EVENT_SUCCESS,
  payload: event,
});
const addEventFail = (error) => ({ type: actionTypes.ADD_EVENT_FAIL, error });

export const resetEventsError = () => ({
  type: actionTypes.RESET_EVENTS_ERROR,
});

export const addEvent = (data, userToken) => (dispatch) => {
  dispatch(addEventStart());
  return axios
    .post("/Events", data, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      } else if (
        !response.data.isSuccess &&
        response.data.errorMessage ===
          "User can't set end date before start date."
      ) {
        Swal({
          title: "Error!",
          text: "You can't set start date before end date!",
          type: "error",
          timer: 3000,
        });
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(addEventSuccess(result));
      toast.success("Your event was successfully created");
      return result;
    })
    .catch((err) => {
      dispatch(addEventFail(err));
    });
};

const getEventStart = () => ({ type: actionTypes.GET_EVENT_START });
const getEventSuccess = (event) => {
  event.activationTime = new Date(event.activationTime);
  event.salesEndTime = new Date(event.salesEndTime);
  event.startDate = new Date(event.startDate);
  event.endDate = new Date(event.endDate);

  return {
    type: actionTypes.GET_EVENT_SUCCESS,
    payload: { event },
  };
};
const getEventFail = () => ({ type: actionTypes.GET_EVENT_FAIL });

export const getEvent = (eventId, token, action = '') => (dispatch) => {
  dispatch(getEventStart());
  const queryParams = !!action ? `?action=${action}` : '';

  return axios
    .get(`/Events/${eventId}` + queryParams, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(getEventSuccess(result));
      return { isFound: true };
    })
    .catch((err) => {
      dispatch(getEventFail(err));
      return { isFound: false };
    });
};

export const updateScannedTickets =
  (eventId, token, start, end) => (dispatch) => {
    dispatch(getEventStart());
    return axios
      .get(
        `/Events/${eventId}?startDateForTicketsStats=${start}&endDateForTicketsStats=${end}`,
        { headers: getHeaders(token) }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          return response.data.result;
        }
        throw new Error(response.data.errorMessage);
      })
      .then((result) => {
        dispatch(getEventSuccess(result));
        return { result, isFound: true };
      })
      .catch((err) => {
        dispatch(getEventFail(err));
        return { isFound: false };
      });
  };

const createTicketStart = () => ({ type: actionTypes.CREATE_TICKET_START });
const createTicketSuccess = () => ({ type: actionTypes.CREATE_TICKET_SUCCESS });
const createTicketFail = () => ({ type: actionTypes.CREATE_TICKET_FAIL });

export const createTicket = (data, token) => (dispatch) => {
  dispatch(createTicketStart());
  return axios
    .post("/TicketTemplate", data, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      toast.success("Your ticket was successfully created");
      dispatch(createTicketSuccess(result));
      return result.id;
    })
    .catch((err) => {
      dispatch(createTicketFail(err));
    });
};

const createTicketRuleStart = () => ({
  type: actionTypes.CREATE_TICKET_RULE_START,
});
const createTicketRuleSuccess = () => ({
  type: actionTypes.CREATE_TICKET_RULE_SUCCESS,
});
const createTicketRuleFail = () => ({
  type: actionTypes.CREATE_TICKET_RULE_FAIL,
});

export const createTicketRule = (data, token) => (dispatch) => {
  dispatch(createTicketRuleStart());
  return axios
    .post("/TicketRules", data, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(createTicketRuleSuccess());
      return true;
    })
    .catch((err) => {
      dispatch(createTicketRuleFail());
    });
};

const updateTicketRuleStart = () => ({
  type: actionTypes.UPDATE_TICKET_RULE_START,
});
const updateTicketRuleSuccess = () => ({
  type: actionTypes.UPDATE_TICKET_RULE_SUCCESS,
});
const updateTicketRuleFail = () => ({
  type: actionTypes.UPDATE_TICKET_RULE_FAIL,
});

export const updateTicketRule = (data, token) => (dispatch) => {
  dispatch(updateTicketRuleStart());

  return axios
    .put(`/TicketRules/${data.id}`, data, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(updateTicketRuleSuccess(result));
      return true;
    })
    .catch((err) => {
      dispatch(updateTicketRuleFail(err));
    });
};

const removeTicketRuleStart = () => ({
  type: actionTypes.REMOVE_TICKET_RULE_START,
});
const removeTicketRuleSuccess = () => ({
  type: actionTypes.REMOVE_TICKET_RULE_SUCCESS,
});
const removeTicketRuleFail = () => ({
  type: actionTypes.REMOVE_TICKET_RULE_FAIL,
});

export const removeTicketRule = (id, token) => (dispatch) => {
  dispatch(removeTicketRuleStart());
  axios
    .delete(`/TicketRules/${id}`, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(removeTicketRuleSuccess(result));
    })
    .catch((err) => {
      dispatch(removeTicketRuleFail(err));
    });
};

const getTicketStart = () => ({ type: actionTypes.GET_TICKET_START });
const getTicketSuccess = (ticket) => ({
  type: actionTypes.GET_TICKET_SUCCESS,
  payload: { ticket },
});
const getTicketFail = () => ({ type: actionTypes.GET_TICKET_FAIL });

export const getTicket = (id, token) => (dispatch) => {
  dispatch(getTicketStart());
  return axios
    .get(`/TicketTemplate/${id}`, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(getTicketSuccess(result));
      return { isFound: true };
    })
    .catch((err) => {
      dispatch(getTicketFail(err));
      return { isFound: false };
    });
};

const updateTicketStart = () => ({ type: actionTypes.GET_UPDATE_TICKET_START });
const updateTicketSuccess = (data) => ({
  type: actionTypes.GET_UPDATE_TICKET_SUCCESS,
  payload: data,
});
const updateTicketFail = () => ({ type: actionTypes.GET_UPDATE_TICKET_FAIL });

export const updateTicket = (data, token) => (dispatch) => {
  dispatch(updateTicketStart());
  return axios
    .put(`/TicketTemplate/${data.id}`, data, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(updateTicketSuccess(data));
      toast.success("Your ticket was successfully edited");
      return true;
    })
    .catch((err) => {
      dispatch(updateTicketFail(err));
    });
};

const removeTicketStart = () => ({ type: actionTypes.REMOVE_TICKET_START });
const removeTicketSuccess = () => ({ type: actionTypes.REMOVE_TICKET_SUCCESS });
const removeTicketFail = () => ({ type: actionTypes.REMOVE_TICKET_FAIL });

export const removeTicket = (id, token) => (dispatch) => {
  dispatch(removeTicketStart());
  return axios
    .delete(`/TicketTemplate/${id}`, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(removeTicketSuccess(result));
      toast.success("Your ticket was successfully deleted");
      return true;
    })
    .catch((err) => {
      dispatch(removeTicketFail(err));
    });
};

const deleteEventStart = () => ({ type: actionTypes.DELETE_EVENT_START });
const deleteEventSuccess = (eventId) => ({
  type: actionTypes.DELETE_EVENT_SUCCESS,
  payload: eventId,
});
const deleteEventFail = (error) => ({
  type: actionTypes.DELETE_EVENT_FAIL,
  error,
});

export const deleteEvent = (userToken, eventId) => (dispatch) => {
  dispatch(deleteEventStart());
  return axios
    .delete(`/Events/${eventId}`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      toast.success("Your event was successfully deleted");
      return result;
    })
    .catch((err) => {
      dispatch(deleteEventFail(err));
    });
};

export const sendResalePurposes = (eventId) => (dispatch) => {
  return axios
    .post(`/SeasonRefuse/SendResalePurposes?eventId=${eventId}`)
    .then((result) => {
      toast.success(
        "Season pass owners will receive an email with link for reselling seats for this game."
      );
      return result;
    });
};

const updateEventStart = () => ({ type: actionTypes.UPDATE_EVENT_START });
const updateEventSuccess = (eventId) => ({
  type: actionTypes.UPDATE_EVENT_SUCCESS,
  payload: eventId,
});
const updateEventFail = (error) => ({
  type: actionTypes.UPDATE_EVENT_FAIL,
  error,
});

export const updateHeaderImage = (userToken, eventId, files, imageType = 1) => (dispatch) => {
  dispatch(updateEventStart());
  const body = new FormData();
  body.append("imageFile", files[0]);

  return axios
    .put(`/Events/${eventId}/EventImage?eventImageType=${imageType}`, body, {
      headers: getHeaders(userToken),
    })
    .then((res) => {
      dispatch(getEvent(eventId, userToken));

      return res.data.result;
    })
    .catch((err) => {
      toast.error("Something went wrong. Try later");
      dispatch(updateEventFail(err));
    });
};

export const deleteImage = (eventId, imageType) => async (dispatch) => {
  dispatch(getWalletInfoStart());

  const user = ls.get("user");

  return axios
    .delete(`/Events/${eventId}/EventImage?eventImageType=${imageType}`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getWalletInfoSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getWalletInfoFail());

      toast.error("Wallet info not got")
    });
};

export const getSeasons = (userToken) => (dispatch) => {
  return axios
    .get("/Season/All", {
      headers: getHeaders(userToken),
    })
    .then(({ data }) => (data && data.isSuccess ? data.result : []));
};

export const updateEvent = (userToken, eventId, data) => (dispatch) => {
  dispatch(updateEventStart());
  return axios
    .put(`/Events/${eventId}`, data, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data;
      } else if (
        !response.data.isSuccess &&
        response.data.errorMessage ===
          "User can't set end date before start date."
      ) {
        Swal({
          title: "Error!",
          text: "You can't set start date before end date!",
          type: "error",
          timer: 3000,
        });
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(updateEventSuccess(eventId));
      toast.success("Your event was successfully edited");
      return result;
    })
    .catch((err) => {
      dispatch(updateEventFail(err));
    });
};

const getEventSellStatsStart = () => ({
  type: actionTypes.GET_EVENT_SELL_STATS_START,
});
const getEventSellStatsSuccess = (payload) => ({
  type: actionTypes.UPDATE_EVENT_SELL_STATISTIC,
  payload,
});
const getEventSellStatsFail = () => ({
  type: actionTypes.GET_EVENT_SELL_STATS_FAIL,
});

export const getEventSellStats = (eventId, token) => (dispatch) => {
  dispatch(getEventSellStatsStart());
  return axios
    .get(`/Events/${eventId}/sell-statistics`, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      const { sellData, ticketNamesMap, teamNamesMap, devicesNamesMap } =
        convertSellDataForStore(result);
      const { dataMap, detailsMap } = convertToDataMap(sellData);
      summedValuesDataMap(
        dataMap,
        detailsMap,
        Array.from(ticketNamesMap.keys()),
        Array.from(teamNamesMap.keys()),
        Array.from(devicesNamesMap.keys())
      );
      dispatch(
        getEventSellStatsSuccess({
          dataMap,
          detailsMap,
          ticketNamesMap,
          teamNamesMap,
          devicesNamesMap,
        })
      );
    })
    .catch((err) => {
      dispatch(getEventSellStatsFail(err));
    });
};

const getEventScanStatsStart = () => ({
  type: actionTypes.GET_EVENT_SCAN_STATS_START,
});
const getEventScanStatsSuccess = (payload) => ({
  type: actionTypes.UPDATE_EVENT_SCAN_STATISTIC,
  payload,
});
const getEventScanStatsFail = () => ({
  type: actionTypes.GET_EVENT_SCAN_STATS_FAIL,
});

export const getEventScanStats = (eventId, token) => (dispatch) => {
  dispatch(getEventScanStatsStart());
  return axios
    .get(`/Events/${eventId}/scan-statistics`, { headers: getHeaders(token) })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      const { scanData, ticketNamesMap, teamNamesMap, devicesNamesMap } =
        convertScanDataForStore(result);
      const { dataMap, detailsMap } = convertToDataMap(scanData);
      summedValuesDataMap(
        dataMap,
        detailsMap,
        Array.from(ticketNamesMap.keys()),
        Array.from(teamNamesMap.keys()),
        Array.from(devicesNamesMap.keys())
      );
      dispatch(
        getEventScanStatsSuccess({
          dataMap,
          detailsMap,
          ticketNamesMap,
          teamNamesMap,
          devicesNamesMap,
        })
      );
    })
    .catch((err) => {
      console.log(err);
      dispatch(getEventScanStatsFail(err));
    });
};

const getWalletInfoStart = () => ({
  type: actionTypes.GET_WALLET_INFO_START,
});
const getWalletInfoSuccess = (payload) => ({
  type: actionTypes.GET_WALLET_INFO_SUCCESS,
  payload,
});
const getWalletInfoFail = () => ({
  type: actionTypes.GET_WALLET_INFO_FAIL,
});

export const getWalletInfo = (eventId) => async (dispatch) => {
  dispatch(getWalletInfoStart());

  const user = ls.get("user");

  return axios
    .get(`/Events/${eventId}/WalletInfo`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getWalletInfoSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getWalletInfoFail());

      toast.error("Wallet info not received")
    });
};

const getWalletSamplesSuccess = (payload) => ({
  type: actionTypes.GET_WALLET_SAMPLES_SUCCESS,
  payload,
});

export const getWalletSamples = (eventId) => async (dispatch) => {
  dispatch(getWalletInfoStart());

  const user = ls.get("user");

  return axios
    .get(`/Events/${eventId}/WalletSamples`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getWalletSamplesSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getWalletInfoFail());

      toast.error("Wallet samples not got")
    });
};

const getEventsStatisticsSuccess = (payload) => ({
  type: actionTypes.GET_EVENTS_STATISTICS_SUCCESS,
  payload,
});

export const getEventsStatistics = ({ eventId, startDate, endDate }) => async (dispatch) => {
  const user = ls.get("user");

  return axios
    .get(`/Events/TransactionStatistics`, {
      headers: getHeaders(user.token),
      params: { eventId, startDate, endDate },
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getEventsStatisticsSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error("Statistic not received")
    });
};

const getEventThemeStart = () => ({
  type: actionTypes.GET_EVENT_THEME_START,
});
const getEventThemeSuccess = (payload) => ({
  type: actionTypes.GET_EVENT_THEME_SUCCESS,
  payload,
});
const getEventThemeFail = () => ({
  type: actionTypes.GET_EVENT_THEME_FAIL,
});

export const getEventTheme = (eventId) => async (dispatch) => {
  dispatch(getEventThemeStart());

  const user = ls.get("user");

  return axios
    .get(`/PageUiTheme/Event/${eventId}`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getEventThemeSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getEventThemeFail());

      toast.error("Event theme not received")
    });
};

const updateEventThemeSuccess = () => ({
  type: actionTypes.UPDATE_EVENT_THEME_SUCCESS,
});

export const updateEventTheme = (eventId, data) => async (dispatch) => {
  dispatch(getEventThemeStart());

  const user = ls.get("user");

  return axios
    .put(`/PageUiTheme/Event/${eventId}`, data, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(updateEventThemeSuccess());

        toast.success("Event theme is updated");

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getEventThemeFail());

      toast.error("Event theme not updated");
    });
};

const deleteEventThemeSuccess = () => ({
  type: actionTypes.DELETE_EVENT_THEME_SUCCESS,
});

export const deleteEventTheme = (eventId) => async (dispatch) => {
  dispatch(getEventThemeStart());

  const user = ls.get("user");

  return axios
    .delete(`/PageUiTheme/Event/${eventId}`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(deleteEventThemeSuccess());

        toast.success("Event theme is updated");

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      dispatch(getEventThemeFail());

      toast.error("Event theme not updated");
    });
};

const getEventMapsSuccess = (payload) => ({
  type: actionTypes.GET_EVENT_MAPS_SUCCESS,
  payload,
});

export const getEventMaps = () => async (dispatch) => {
  const user = ls.get("user");

  return axios
    .get(`/MapSeats/Maps`, {
      headers: getHeaders(user.token),
    })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getEventMapsSuccess(response.data.result));

        return response.data.result;
      };

      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error("Event maps not received")
    });
};
